export const CLOSE_CSV_UPLOAD = 'CLOSE_CSV_UPLOAD'

export default () => ({
  type: CLOSE_CSV_UPLOAD,
})
